/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2023-01-05 14:46:49
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-05 16:29:27
 */
import { defineStore } from '@main/common/config/defineStore'
import { apiGetFindDictItem } from '../api/dictValue'
// import { defineStore } from 'pinia'
// 第一个参数是应用程序中 store 的唯一 id
export default defineStore('dictValue', {
  state: () => ({
    dictOptions: {}
  }),
  // 相当于 vue 中的 computed 计算属性 返回一个数值
  getters: {
    getDictItem: (state, dictKey) => {
      return state.dictOptions[dictKey]
    }
  },
  actions: {
    getSelectionDict(dictKey) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            if (!this.dictOptions.dictKey) {
              const { data } = await apiGetFindDictItem(dictKey)
              this.dictOptions[dictKey] = data
            }
            resolve(this.dictOptions[dictKey])
          } catch (error) {
            reject(error)
          }
        })()
      })
    }
  }
})
